// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class QuerySuggestionsPlugin {
   appState: any
   config: any
   static initClass() {
      // @ts-expect-error TS(2339) FIXME: Property 'states' does not exist on type 'QuerySug... Remove this comment to see the full error message
      this.prototype.states = ['new']
   }
   constructor(appState: any, configService: any) {
      this.invoke = this.invoke.bind(this)
      this.appState = appState
      this.config = configService.data.results
   }
   invoke(data: any, feed: any) {
      const qs = data.search.recommendations.query_suggestions
    
      if (qs && qs.length && this.config.enableQuerySuggestions) {
         const item = {
            queries: qs.map((q: any) => q.query),
            holdingsOnly: this.appState.params.ho && this.config.addResultsBeyondCatalog,
            type: 'querySuggestions'
         }
         return feed.addPositionalItem(item, 11)
      }
   }
}
QuerySuggestionsPlugin.initClass()

QuerySuggestionsPlugin.$inject = ['appStateService', 'configService']

angular.module('summonApp.resultsFeedPlugins')
   .service('querySuggestionsPlugin', QuerySuggestionsPlugin)
